<template>
	<el-row>
		<el-button type="primary" size="medium" @click="add">+添加</el-button>
		<el-row style="margin: 20px 0;">
			<el-col :span="4">
				<div class="search-view">
					<div>
						广告标题:
					</div>
					<el-input size="mini" v-model="title2"></el-input>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="search-view">
					<div>
						状态:
					</div>
					<el-select size="mini" clearable placeholder="全部" v-model="status">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>

				</div>
			</el-col>
			<el-col :span="6">
				<div class="search-view">
					<div>
						应用分类:
					</div>
					<el-select size="mini" clearable placeholder="全部" v-model="type">
						<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button type="primary" size="mini" style="margin-left: 10px;" @click="shuaixuan">筛选</el-button>
					<el-button type="warning" size="mini" style="margin-left: 10px;" @click="zhikong">置空</el-button>
				</div>
			</el-col>
		</el-row>
		<el-table :data="tableDate">
			<el-table-column label="序号" prop="id"></el-table-column>
			<el-table-column label="页面名称" prop="pic">
				<template slot-scope="scope">
					<el-image :src="scope.row.pic" style="width: 100px;height: 100px;"></el-image>
				</template>
			</el-table-column>
			<el-table-column label="广告标题" prop="title"></el-table-column>
			<el-table-column label="排序" prop="sort"></el-table-column>
			<el-table-column label="应用分类">
				<template slot-scope="scope">
					{{ scope.row.type == 1 ? '课程首页' : '' }}
				</template>
			</el-table-column>
			<el-table-column label="开始时间" prop="created"></el-table-column>
			<el-table-column label="结束时间" prop="startTime"></el-table-column>
			<el-table-column label="状态" prop="status">
				<template slot-scope="scope">
					<el-switch :active-value="0" :inactive-value="1" @change="isStatus(scope.row)" active-text="正常"
						inactive-text="禁用" v-model="scope.row.status">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="del(scope.row)" style="color: red;">删除</el-button>
					<el-button type="text" @click="bj(scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="30%" center @close="gb">
			<el-form ref="info" :model="info" :rules="infoRules" label-position="right" label-width="90px">
				<el-form-item label="广告图片:" prop="pic">
					<el-button @click="drawer = true" type="primary" size="mini" style="margin-bottom: 10px;">
						图片库上传
					</el-button>
					<el-upload :class="{ hide: true }" :action="uploadUrl" list-type="picture-card" :limit="1"
						:on-success="getPictrueURL" :on-preview="handlePictureCardPreview" accept=".jpg,.png.gif"
						:file-list="fileList" :on-remove="handleRemove" :before-upload="beforeUpload">
						<i class="el-icon-plus" />
					</el-upload>
					<el-dialog :append-to-body="true" :visible.sync="dialogDisplay" size="tiny"
						@close="imagePrevClosed">
						<el-image width="100%" :src="dialogImageUrl"></el-image>
					</el-dialog>
				</el-form-item>
				<el-form-item label="广告标题:" prop="title">
					<el-input v-model="info.title"></el-input>
				</el-form-item>
				<el-form-item label="应用端口:" prop="type">
					<el-select v-model="info.type">
						<el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="广告链接:" prop="url">
					<el-input placeholder="小程序页面路径" v-model="info.url"></el-input>
				</el-form-item>
				<el-form-item label="排序:" prop="sort">
					<el-input-number :min="1" v-model="info.sort"></el-input-number>
				</el-form-item>
				<el-form-item>
					<el-button type="infor" @click="centerDialogVisible = false">取消</el-button>
					<el-button type="primary" @click="queren">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-drawer title="图片选择" :visible.sync="drawer" direction="rtl" size="40%">
			<SelectPicture :imgNum="1" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>

<script>
	import httpClient from '../../../util/request.js';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			SelectPicture
		},
		data() {
			return {
				radioValue: '0',
				drawer: false,
				uploadUrl: httpClient.imgUrl,
				total: 0,
				pageNum: 1,
				pageSize: 30,
				pagelist: [30, 50, 100],
				hideUpload: false,
				DialogVisible: false,
				dialogDisplay: false, // 上传图片弹窗
				dialogImageUrl: "", //上传图片控件预览url
				fileList: [],
				centerDialogVisible: false,
				title: '',
				title2: '',
				status: '',
				type: '',
				options: [{
						value: '',
						label: '全部'
					},
					{
						value: 0,
						label: '启用'
					},
					{
						value: 1,
						label: '禁用'
					}
				],
				options2: [{
						value: '',
						label: '全部'
					},
					{
						value: 1,
						label: '课程首页'
					},
				],
				options3: [{
					value: 1,
					label: '微信小程序'
				}],
				tableDate: [],
				infoRules: {
					pic: [{
						required: true,
						trigger: "blur",
						message: "请上传广告图片",
					}],
					title: [{
						required: true,
						trigger: "blur",
						message: "请输入广告标题",
					}],
					url: [{
						required: true,
						trigger: "blur",
						message: "请输入广告链接",
					}],
					type: [{
						required: true,
						trigger: "blur",
						message: "请输入应用端口",
					}],
					sort: [{
						required: true,
						trigger: "blur",
						message: "请输入排序",
					}]
				},
				info: {
					id: '',
					pic: "",
					title: "",
					url: "",
					type: 1,
					sort: "",
				}
			}
		},
		methods: {
			getImg(e) {
				console.log(e);
				this.info.pic = e
				this.fileList = [];
				[e].forEach(item => {
					this.fileList.push({
						url: item
					})
				})
				this.drawer = false
			},
			gb() {
				this.getInfo()
			},
			isStatus(row) {
				console.log(row);
				this.$http.post(`/api/course/ClrRotationManageController/edit`, {
					id: row.id,
					status: row.status,
					startTime: this.getnowdata(),
					endTime: this.getnowdata()
				}).then(res => {
					console.log(res);
				})
			},
			zhikong() {
				this.status = ''
				this.type = ''
				this.title2 = ''
				this.getInfo()
			},
			shuaixuan() {
				console.log(this.status);
				this.getInfo()
			},
			del(row) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/course/ClrRotationManageController/edit`, {
						id: row.id,
						deleteStatus: 1,
						startTime: this.getnowdata(),
						endTime: this.getnowdata()
					}).then(res => {
						console.log(res);
						if (res.data.status == 0) {
							this.$message.success('删除成功')
							this.getInfo()
						} else {
							this.$message.error('修改失败')
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			bj(row) {
				console.log(row);
				this.hideUpload = true
				this.centerDialogVisible = true
				this.title = '编辑'
				this.fileList = []
				this.fileList.push({
					url: row.pic
				})
				this.info.pic = row.pic
				this.info.title = row.title
				this.info.url = row.url
				this.info.sort = row.sort
				this.info.id = row.id
			},
			add() {
				this.centerDialogVisible = true
				this.title = '添加'
				this.info.pic = ''
				this.info.title = ''
				this.info.type = ''
				this.info.url = ''
				this.info.sort = ''
				this.fileList = []
				this.hideUpload = false
			},
			//获取当前时间
			getnowdata() {
				var date = new Date();
				var sign1 = "-";
				var sign2 = ":";
				var year = date.getFullYear(); // 年
				var month = date.getMonth() + 1; // 月
				var day = date.getDate(); // 日
				var hour = date.getHours(); // 时
				var minutes = date.getMinutes(); // 分
				var seconds = date.getSeconds(); //秒
				// 给一位数数据前面加 “0”
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (day >= 0 && day <= 9) {
					day = "0" + day;
				}
				if (hour >= 0 && hour <= 9) {
					hour = "0" + hour;
				}
				if (minutes >= 0 && minutes <= 9) {
					minutes = "0" + minutes;
				}
				if (seconds >= 0 && seconds <= 9) {
					seconds = "0" + seconds;
				}
				var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 +
					seconds;
				return currentdate;
			},
			queren() {
				this.$refs.info.validate((valid) => {
					if (valid) {
						if (this.title == '添加') {
							this.$http.post(`/api/course/ClrRotationManageController/add`, {
								pic: this.info.pic,
								title: this.info.title,
								url: this.info.url,
								type: this.info.type,
								sort: this.info.sort,
								startTime: this.getnowdata(),
								endTime: this.getnowdata()
							}).then(res => {
								console.log(res);
								if (res.data.status == 0) {
									this.$message.success('添加成功')
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error('添加失败')
								}
							})
						} else if (this.title == '编辑') {
							this.$http.post(`/api/course/ClrRotationManageController/edit`, {
								id: this.info.id,
								pic: this.info.pic,
								title: this.info.title,
								url: this.info.url,
								type: this.info.type,
								sort: this.info.sort,
								startTime: this.getnowdata(),
								endTime: this.getnowdata()
							}).then(res => {
								console.log(res);
								if (res.data.status == 0) {
									this.$message.success('修改成功')
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error('修改失败')
								}
							})
						}

					}
				})
			},
			getPictrueURL(res, file, fileList) {
				this.info.pic = res.data
				this.hideUpload = fileList.length >= 1
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
			handleRemove(file, fileList) {
				this.info.pic = ''
				this.hideUpload = false
			},
			beforeUpload(file) {
				console.log(file);
				const isLt10M = file.size / 1024 / 1024 < 10
				if (!isLt10M) {
					this.$message.error('上传文件大小不能超过 10MB!');
				}
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
			getInfo() {
				this.$http.get(
					`/api/course/ClrRotationManageController/selectList?pageNum=${this.pageNum}&pageSize=${this.pageSize}&title=${this.title2}&type=${this.type}&status=${this.status}`, {}
				).then(res => {
					console.log(res.data.data.list);
					this.total = res.data.data.total
					this.tableDate = res.data.data.list
				})
			}
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">
	/deep/.el-input-number__increase {
		right: -38px;
	}

	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>
